import { useRef } from 'react';
import { getIconTooltipIconStyles } from './IconTooltipStyles.js';
import { jsxs, Fragment, jsx } from '@emotion/react/jsx-runtime';
import { useHoverableTooltip } from '../Tooltip/useTooltip.js';
import { Icon } from '../Icon/Icon.js';
import { Tooltip } from '../Tooltip/Tooltip.js';

function IconTooltip(_ref) {
  let {
    children,
    size,
    icon,
    tooltipId = 'icon-tooltip',
    placement,
    onClickAway,
    container,
    hideTooltip = false,
    ...props
  } = _ref;
  const tooltipRef = useRef(null);
  const {
    opened
  } = useHoverableTooltip(tooltipRef);
  return jsxs(Fragment, {
    children: [jsx("i", {
      css: getIconTooltipIconStyles,
      ...props,
      ref: tooltipRef,
      "aria-describedby": tooltipId,
      children: jsx(Icon, {
        size: size,
        name: icon
      })
    }), jsx(Tooltip, {
      id: tooltipId,
      reference: tooltipRef.current,
      placement: placement,
      onClickAway: onClickAway,
      isOpen: opened && !hideTooltip,
      container: container,
      children: children
    })]
  });
}

export { IconTooltip };
//# sourceMappingURL=IconTooltip.js.map
